var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMovieLinkArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5133 5.18439C11.1622 5.54688 11.1622 6.45312 10.5133 6.81561L1.46018 11.8724C0.811208 12.2349 -3.27557e-08 11.7818 0 11.0568L4.56942e-07 0.943194C4.89698e-07 0.218204 0.81121 -0.234914 1.46018 0.127581L10.5133 5.18439Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovieLinkArrow);
export default __webpack_public_path__ + "static/media/movie-link-arrow.09f17ecdee47ab2f1af6fbf2f9020463.svg";
export { ForwardRef as ReactComponent };